module.exports = __webpack_public_path__ + "static/media/semanticNav.c7a22d16.png";